export const frenchDipUSStartDate = new Date(2025, 10, 19); // November 19, 2025
export const frenchDipUSEndDate = new Date(2026, 2, 1, 23, 59, 59); // March 01, 2026
export const frenchDipUSUrl = '/menu/section-39f0c606-790a-4edd-a322-74cded7c2f51';

export const frenchDipCAStartDate = new Date(2024, 11, 1); // December 1, 2024
export const frenchDipCAEndDate = new Date(2025, 2, 2, 23, 59, 59); // March 02, 2025
export const frenchDipCAUrl = '/menu/section-b95bc971-3838-495c-9c8f-93183e68a539';

export const hotSauceBarCanadaStartDate = new Date(2024, 11, 1); // December 1, 2024
export const hotSauceBarCanadaEndDate = new Date(2025, 0, 27, 23, 59, 59); // January 27, 2025

export const tripleStackUSStartDate = new Date(2025, 5, 16); // June 16, 2025
export const tripleStackUSEndDate = new Date(2025, 8, 30, 23, 59, 59); // September 30, 2025

export const thanksgivingSubCAStartDate = new Date(2025, 8, 15); // September 15, 2025
export const thanksgivingSubCAEndDate = new Date(2025, 9, 5, 23, 59, 59); // October 5, 2025

export const thanksgivingSubUSStartDate = new Date(2025, 8, 29); // September 29, 2025
export const thanksgivingSubUSEndDate = new Date(2025, 10, 9, 23, 59, 59); // Nov 9, 2025

export const firstRespondersMonthStartDate = new Date(2025, 9, 0); // October 1, 2025
export const firstRespondersMonthEndDate = new Date(2025, 9, 31, 23, 59, 59); // October 31, 2025

export const montrealSmokedMeatCAStartDate = new Date(2025, 9, 29); // October 29, 2025
export const montrealSmokedMeatCAEndDate = new Date(2026, 1, 16, 23, 59, 59); // Feb 16, 2026
